/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import './tailwind.css';
import React from 'react';
import Application from 'app/index';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { advisorUpdated, userUpdated } from './app/actions/shared_actions';
import { reviewsLoaded, updateAdvisorNavigationStack } from './app/actions/advisors';
import {
  getAdvisorDataIfSsrMode, getActivePromotionData, getHomePageDataIfSsrMode, getSearchResultsData, isPrerenderMode
} from './app/config/util';
import { homeLoadedActions } from './app/actions/home_page';
import { setAnonymousUserAction } from './app/actions/application';
import { refreshReducersFromResponse } from './app/config/api_functions';
import { getAdvisorsStatuses } from './common/api/api';

window.sessionId = Math.floor(10000 + Math.random() * 90000);

if (!Object.hasOwn) {
  Object.hasOwn = (obj, prop) => {
    if (obj === null || typeof obj !== 'object' && typeof obj !== 'function') {
      throw new TypeError('Object.hasOwn called on non-object');
    }
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('app-root');
  let hydration = false;

  // hydrate advisor page if need
  const advisorData = getAdvisorDataIfSsrMode();
  if (advisorData) {
    const {
      advisor, reviews, user
    } = advisorData;
    if (advisor) {
      window.store.dispatch(advisorUpdated(advisor));
      updateAdvisorNavigationStack({ advisor, dispatch: window.store.dispatch });
    }
    if (reviews) {
      window.store.dispatch(reviewsLoaded({
        reviews, id: advisor?.id, initial: true
      }));
    }
    if (user) {
      window.store.dispatch(userUpdated(user));
    }

    hydration = true;
  }

  // hydrate search result page if need
  const searchResultsData = getSearchResultsData();
  if (searchResultsData) {
    window.searchResultsData = searchResultsData;
    hydration = true;
  }

  // hydrate anonymous user if need
  const activePromotionData = getActivePromotionData();
  if (activePromotionData) {
    window.store.dispatch(setAnonymousUserAction({ activePromotions: [activePromotionData] }));
    hydration = true;
  }

  // hydrate home page if need
  const homePageData = getHomePageDataIfSsrMode();
  if (homePageData) {
    const { sections } = homePageData;
    if (sections && sections.some(section => section.content?.advisors?.length > 0)) {
      window.homePageData = homePageData;
      window.store.dispatch(homeLoadedActions(sections));
      const advisorsIds = sections.reduce((arr, section) => {
        if (section.content?.advisors?.length) {
          arr.push(...section.content.advisors.map(x => x.id));
        }
        return arr;
      }, []);
      if (advisorsIds.length > 0) {
        getAdvisorsStatuses(advisorsIds).then(res => refreshReducersFromResponse(res));
      }

      hydration = true;
    }
  }

  if (!isPrerenderMode() && hydration) {
    hydrateRoot(container, <Application />);
    return;
  }

  const root = createRoot(container);
  root.render(<Application />);

  if (isPrerenderMode()) {
    const comment = document.createComment(`Page generated at ${ new Date().toISOString() }`);
    container.appendChild(comment);
  }
});
